import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import GroupLeader from './components/GroupLeader';
import DeploymentRegCount from './components/DeploymentRegCount';
import Deployment from './components/Deployment';
import SectorDeployment from './components/SectorDeployment';
import DistrictReg from './components/DistrictReg';
import SamithyWiseReg from './components/SamithyWisereg';
import RegisteredMemberDetails from './components/RegisteredMemberDetails';
import SevadalDetails from './components/Sevadal';
import SevadalDistrictAndSamithiReg from './components/SevadalDis&SamithiReg';
import SevadalSamithiReg from './components/SevadalSamithiReg';
import AgeGroupReport from './components/AgeGroupReport';
import BloodGroupReport from './components/BloodGroup';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';

export default function ReportPage() {
    const [selectedComponent, setSelectedComponent] = useState('regCount');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Ref to dropdown container

    const reports = [
        { value: 'regCount', label: 'Deployment Register Count' },
        { value: 'deployment', label: 'Deployment' },
        { value: 'sector', label: 'Sector Deployment' },
        { value: 'groupLeader', label: 'Group Leader' },
        { value: 'districtreg', label: 'District Registration' },
        { value: 'samithireg', label: 'Samithy wise Registration' },
        { value: 'regmember', label: 'Registration Member Details' },
        { value: 'sevadal', label: 'Sevadal' },
        { value: 'sevadaldist', label: 'Sevadal (District/Samithy) Registration' },
        { value: 'sevadalsamithi', label: 'Sevadal Samithy Registration' },
        { value: 'ageGroup', label: 'Age Group' },
        { value: 'bloodGroup', label: 'Blood Group' },
    ];

    const navigate = useNavigate();

    useEffect(() => {
        const role = localStorage.getItem('role');

        if (!role) {
            navigate('/login-screen');
        }

        if (role == 'basic') {
            navigate('/dashboard');
        }

    }, [navigate]);

    const handleSelect = (value) => {
        setSelectedComponent(value);
        setDropdownOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="p-2 pt-0">
            <Header />
            <Breadcrumb />
            <div className="block w-full max-w-7xl mx-auto">
                <div className="inline-flex w-100 md:w-3/5 mb-4 justify-between items-center mt-4 relative text-left" ref={dropdownRef}>
                    {/* <h2 className="text-xl font-semibold">{reports.find(r => r.value === selectedComponent)?.label} Report</h2> */}
                    <div className="flex items-center">
                        <label className="mr-2 font-medium block">Select Report:</label>
                        <div className="relative md:w-80 w-auto">
                        <button
                            type="button"
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="md:w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                        >
                            <div className="flex justify-between items-center">
                                <span>{reports.find(r => r.value === selectedComponent)?.label || 'Select'}</span>
                                <svg
                                    className={`ml-2 h-5 w-5 transform transition-transform ${dropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                        </button>

                        {dropdownOpen && (
                            <ul className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg max-h-60 overflow-auto ring-1 ring-black ring-opacity-5 focus:outline-none">
                                {reports.map((report) => (
                                    <li
                                        key={report.value}
                                        className={`cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${
                                            selectedComponent === report.value ? 'bg-gray-100 font-semibold' : ''
                                        }`}
                                        onClick={() => handleSelect(report.value)}
                                    >
                                        {report.label}
                                    </li>
                                ))}
                            </ul>
                        )}
                        </div>
                    </div>
                    
                    
                </div>
                {selectedComponent === 'groupLeader' && <GroupLeader />}                                
                {selectedComponent === 'regCount' && <DeploymentRegCount />}
                {selectedComponent === 'deployment' && <Deployment />}
                {selectedComponent === 'sector' && <SectorDeployment />}
                {selectedComponent === 'districtreg' && <DistrictReg />}
                {selectedComponent === 'samithireg' && <SamithyWiseReg />}
                {selectedComponent === 'regmember' && <RegisteredMemberDetails />}
                {selectedComponent === 'sevadal' && <SevadalDetails />}
                {selectedComponent === 'sevadaldist' && <SevadalDistrictAndSamithiReg />}
                {selectedComponent === 'sevadalsamithi' && <SevadalSamithiReg />}
                {selectedComponent === 'ageGroup' && <AgeGroupReport />}
                {selectedComponent === 'bloodGroup' && <BloodGroupReport />}
            </div>
        </div>
    );
}